const sanitizeString = (str) => {
    str = str.replace(/(<([^>]+)>|[\u0000-\u001f\u007f-\u009f]|[\u2028\u2029])/gi, "");
    str = str.replace(/%20/g, ' ');

    str = str.trim();
    return str;
}

export default sanitizeString